import React, { useState } from 'react';
import styled from 'styled-components';
import { useClosePopup } from '../../../utils/hooks/usePopup';
import Button from '../../../elements/Button';
import Popup from 'src/layout/Popup';
import { formatPrice } from 'src/utils/Util';
import Accounting, { AccountableAuction } from 'src/utils/api/accounting/Accounting';
import { useUser } from 'src/pn-trading-sdk/utils/UserToken';
import Checkbox from 'src/elements/Checkbox';

export default function DiscloseItems({ auction, itemIds, commissionPercentage, commisionTotal, onComplete}: Props) {
	const close = useClosePopup();
	const [loading, setLoading] = useState(false)
	const [internalOnly, setInternalOnly] = useState(false)

	const user = useUser()

	const confirm = async () => {
		setLoading(true);
		try {
			console.log('accounting')
			await Accounting.discloseItems(auction.id, commissionPercentage, itemIds, internalOnly);
			if (onComplete) onComplete();
			close();
		} catch (e) {
			alert('Något gick fel');
			console.error(e);
		} finally {
			setLoading(false);
		}
	};

	const ownedItems = auction.items.filter(i => i.owned === true && itemIds.includes(i.id));
	const ownedItemsTotal = ownedItems.reduce((acc, i) => acc + i.net_amount + i.vat_amount, 0);

	const toDisclose = commisionTotal * 1.25 + auction.service_fee_net + auction.service_fee_vat + ownedItemsTotal;

	return (
		<Popup close={close} width="40em" maxWidth="25em">
			<Style>
				<h2 className="title">Redovisa intäkt</h2>
				<div className="spacer s"></div>
				<p>Intäkten enligt nedan kommer att redovisas och de berörda objekten kommer att markeras som redovisade i systemet.</p>
				<div className="spacer s"></div>
				<pre>
					Provision: <strong>{formatPrice(commisionTotal * 1.25)}</strong><br />
					Serviceavgift: <strong>{formatPrice(auction.service_fee_net + auction.service_fee_vat)}</strong><br />
					Övrigt: <strong>{formatPrice(ownedItemsTotal)}</strong><br />
					<br />
					Att redovisa: <strong>{formatPrice(toDisclose)}</strong><br />
				</pre>

				<div className="spacer xs"></div>

				{(user as any)?.permissions.includes('developer') && (
					<>
						<Checkbox
							label="Redovisa enbart i CMS"
							checked={internalOnly}
							onChange={(e: any) => {
								setInternalOnly(e.target.checked)
							}}
						/>
					</>
				)}

				<div className="buttons">
					<Button type="secondary" onClick={close}>
						Avbryt
					</Button>
					<Button onClick={confirm} disabled={loading} className={loading ? 'loading' : ''}>Redovisa</Button>
				</div>
			</Style>
		</Popup>
	);
}

const Style = styled.div``;

type Props = {
	auction: AccountableAuction;
	itemIds: number[];
	commissionPercentage: number;
	commisionTotal: number;
	onComplete?: () => void;
};